export const checkNotEmpty = (obj) => {
    return obj !== undefined && obj !== null && obj !== "";
};